export default {
  text: 'Zamówienie zostało złożone mniej niż 15 minut temu! Potwierdź, czy chcesz kontynuować nowe zamówienie, czy zarządzać istniejącym.',
  buttons: {
    see_existing_order: 'Zobacz istniejące zamówienie',
    proceed_new_order: 'Kontynuuj nowe zamówienie',
  },
};
